export default __webpack_public_path__ + "static/media/section4litmatch2.e7df4041.gif";